module.exports = __webpack_public_path__ + "img/browsers@2x.b734c364.png";